/* eslint-disable react/prop-types */
import { useEffect } from "react";
import { Controller } from "react-hook-form";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { numberPrefix, States } from "@/constants";
import { cn } from "@/lib/utils";

export function RHFSelectInput({
  name,
  control,
  dataToMap,
  ruleMessage = "",
  placeholder = "",
  isValidate = false,
  phoneNumber = "",
}) {
  const prefix =
    phoneNumber && typeof phoneNumber === "string"
      ? phoneNumber.substring(1, 4)
      : "";

  return (
    <Controller
      name={`${name}`}
      control={control}
      rules={ruleMessage ? { required: `${ruleMessage}` } : {}}
      render={({ field }) => {
        useEffect(() => {
          if (isValidate && phoneNumber) {
            const matchedNetwork = Object.entries(numberPrefix).find(
              ([network, prefixes]) => prefixes.includes(prefix),
            );

            if (matchedNetwork) {
              const [network] = matchedNetwork;
              const find = dataToMap.find((prev) => prev.name === network);
              if (find) {
                field.onChange(find.id);
              }
            }
          }
        }, [prefix, isValidate, phoneNumber, dataToMap, field]);

        return (
          <Select
            onValueChange={field.onChange}
            value={field.value}
            className="focus:border-slate-40 w-full rounded-md border border-slate-500 px-3"
          >
            <SelectTrigger className={cn("text-[15px]", "py-5")}>
              <SelectValue
                placeholder={`${placeholder}`}
                className="font-medium"
              />
            </SelectTrigger>
            <SelectContent className="lg:-top-16">
              <SelectGroup className="">
                {dataToMap.map((item, i) => (
                  <SelectItem
                    key={item.id}
                    value={phoneNumber ? item.id : item.name}
                  >
                    {phoneNumber ? item.display : item.name}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        );
      }}
    />
  );
}
